export interface IListMenuWidget {
  sort_stock_menu?: string;
}
